<div class="pending-section" *ngIf="pendingDownloads.length > 0">
  <div class="pending-header">
    <div class="pending-header-left">
      <div class="pending-icon-wrap">
        <grid-icon name="time-outline" size="l"></grid-icon>
      </div>
      <div class="pending-header-text">
        <h3 class="pending-title">Download in elaborazione</h3>
        <p class="pending-subtitle">
          {{ pendingDownloads.length }} {{ pendingDownloads.length !== 1 ? 'sinistri in attesa' : 'sinistro in attesa' }}
          — la pagina si aggiornerà automaticamente
        </p>
      </div>
    </div>
  </div>

  <div class="pending-list">
    <div class="pending-item" *ngFor="let item of pendingDownloads">
      <div class="pending-item-info">
        <span class="pending-claim-number">{{ item.claimNumber }}</span>
        <span class="pending-count" *ngIf="item.totalDocuments > 0">
          {{ item.processedDocuments }} / {{ item.totalDocuments }} documenti
        </span>
        <span class="pending-count pending-count--waiting" *ngIf="item.totalDocuments === 0">
          In attesa...
        </span>
      </div>
      <div class="progress-bar-track">
        <div
          class="progress-bar-fill"
          [style.width.%]="getProgress(item)"
          [class.indeterminate]="item.totalDocuments === 0"
        ></div>
      </div>
    </div>
  </div>
</div>
